/**
 * @generated SignedSource<<aad2b8c5fed54c7ae92b89c82e036f72>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MatchDetailTab_person$data = {
  readonly first_name: string;
  readonly id: number;
  readonly last_name: string;
  readonly " $fragmentSpreads": FragmentRefs<"DefaultRoleSection_person" | "JobTitleSection_person">;
  readonly " $fragmentType": "MatchDetailTab_person";
};
export type MatchDetailTab_person$key = {
  readonly " $data"?: MatchDetailTab_person$data;
  readonly " $fragmentSpreads": FragmentRefs<"MatchDetailTab_person">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MatchDetailTab_person",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "first_name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "last_name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DefaultRoleSection_person"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "JobTitleSection_person"
    }
  ],
  "type": "people",
  "abstractKey": null
};

(node as any).hash = "8b521c11d345b3233e215e09d15b7bd2";

export default node;
